module.exports = __webpack_public_path__ + "img/1440.87f67741.jpg";